// extracted by mini-css-extract-plugin
export default {"hyperlink":"EditorExtension_Link_hyperlink__WAMF1"};